var _path, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartEyesFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11",
    "data-name": "Group 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.782,
    height: 41.782,
    viewBox: "0 0 41.782 41.782",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M913.19,267.766A20.891,20.891,0,1,1,892.3,246.874,20.891,20.891,0,0,1,913.19,267.766Z",
    transform: "translate(-871.408 -246.874)",
    fill: "#f6d66c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0.901 5.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(24.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M931.8,261.894c-3.407-6.5-9.712-1.89-8.609,2.965.872,3.814,5.059,9.227,5.059,9.227.6-.212,6.437-2.317,9.219-5.069C941.01,265.517,938.166,258.246,931.8,261.894Z",
    transform: "translate(-923.064 -258.688)",
    fill: "#cc342f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M880.484,261.894c3.408-6.5,9.713-1.89,8.608,2.965-.87,3.814-5.057,9.227-5.057,9.227-.6-.212-6.437-2.317-9.219-5.069C871.275,265.517,874.118,258.246,880.484,261.894Z",
    transform: "translate(-873.275 -258.688)",
    fill: "#cc342f"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(12.373 25.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M897.93,298.814c-.523-.173-1.014.393-.862,1a8.9,8.9,0,0,0,16.98,0c.152-.605-.339-1.172-.862-1a25.063,25.063,0,0,1-15.255,0Z",
    transform: "translate(-897.04 -298.782)",
    fill: "#562912"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(16.819 28.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M910.322,306.3a4.446,4.446,0,0,0-4.071,2.691,9.309,9.309,0,0,0,8.143,0A4.445,4.445,0,0,0,910.322,306.3Z",
    transform: "translate(-906.251 -306.3)",
    fill: "#cc342f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEyesFace);
export default __webpack_public_path__ + "static/media/heart-eyes-face.904da43f.svg";
export { ForwardRef as ReactComponent };